/**
 * Product Hero V3 - Loop Subscription Integration
 * Manages UI sync with Loop Subscriptions app
 * Only loads when subscriptions are enabled
 * Last Updated: January 2025
 */

(function() {
  'use strict';

  const heroForm = document.getElementById('hero-product-form');
  const productId = heroForm?.dataset.productId;
  
  if (!productId) return;

  console.log('🔄 Loop integration loaded for product:', productId);
  
  let isUpdating = false;
  let isInitialized = false;
  
  function waitForLoop() {
    if (typeof initLoopWidget === 'function') {
      setupLoopIntegration();
    } else {
      setTimeout(waitForLoop, 100);
    }
  }
  
  function setupLoopIntegration() {
    // Hide Loop's native container and buttons
    const loopContainer = document.querySelector(`#loop-subscription-container-${productId}`);
    if (loopContainer) loopContainer.style.display = 'none';
    
    const style = document.createElement('style');
    style.textContent = `
      .loop-add-to-cart, .loop-button, [data-loop-add-to-cart],
      #loop-subscription-container-${productId} button[type="submit"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    
    setupLoopListeners();
    setupCustomUIListeners();
    
    setTimeout(() => {
      updateUIFromLoop();
      setupVariantIntegration();
      isInitialized = true;
    }, 500);
  }
  
  function setupCustomUIListeners() {
    const purchaseOptions = heroForm?.querySelectorAll('input[name="purchase-option"]');
    purchaseOptions?.forEach(option => {
      option.addEventListener('change', function() {
        if (!isUpdating) {
          handlePurchaseOptionChange(this.value);
          updateCTAText(this.value);
        }
      });
    });
    
    const frequencySelect = document.getElementById('hero-frequency-select');
    frequencySelect?.addEventListener('change', function() {
      if (!isUpdating && this.value) {
        handleFrequencyChange(this.value);
      }
    });
  }
  
  function handlePurchaseOptionChange(option) {
    const frequencyContainer = document.getElementById('hero-frequency-container');
    const subscriptionOptions = document.querySelector('.hero-subscription-options');
    
    if (option === 'subscribe') {
      if (frequencyContainer) frequencyContainer.style.display = 'block';
      triggerLoopSubscription();
      
      const frequencySelect = document.getElementById('hero-frequency-select');
      if (frequencySelect?.value) updateFormSellingPlan(frequencySelect.value);
    } else {
      if (frequencyContainer) frequencyContainer.style.display = 'none';
      updateFormSellingPlan('');
      triggerLoopOneTime();
    }
    
    if (subscriptionOptions) subscriptionOptions.style.display = 'block';
  }
  
  function handleFrequencyChange(sellingPlanId) {
    if (isUpdating) return;
    
    isUpdating = true;
    updateFormSellingPlan(sellingPlanId);
    updateLoopSellingPlan(sellingPlanId);
    
    setTimeout(() => {
      isUpdating = false;
      setTimeout(updateCTAPrice, 200);
    }, 1000);
  }
  
  function updateFormSellingPlan(sellingPlanId) {
    if (!heroForm) return;
    
    let input = heroForm.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      heroForm.appendChild(input);
    }
    input.value = sellingPlanId;
  }
  
  function triggerLoopOneTime() {
    if (isUpdating) return;
    const option = document.querySelector(`#loop-one-time-purchase-${productId}`);
    if (option && !option.checked) {
      isUpdating = true;
      option.checked = true;
      option.click();
      setTimeout(() => { isUpdating = false; }, 500);
    }
  }
  
  function triggerLoopSubscription() {
    if (isUpdating) return;
    const loopContainer = document.querySelector(`#loop-subscription-container-${productId}`);
    const options = loopContainer?.querySelectorAll('.loop-subscription-group input[type="radio"]');
    
    if (options?.length > 0 && !options[0].checked) {
      isUpdating = true;
      options[0].checked = true;
      options[0].click();
      setTimeout(() => { isUpdating = false; }, 500);
    }
  }
  
  function updateLoopSellingPlan(sellingPlanId) {
    const loopContainer = document.querySelector(`#loop-subscription-container-${productId}`);
    if (!loopContainer || isUpdating) return;
    
    let updated = false;
    
    // Try select dropdowns first
    loopContainer.querySelectorAll('.loop-selling-plan-selector').forEach(select => {
      if (select.querySelector(`option[value="${sellingPlanId}"]`) && select.value !== sellingPlanId) {
        select.value = sellingPlanId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        updated = true;
      }
    });
    
    // Try radio buttons
    if (!updated) {
      loopContainer.querySelectorAll('.custom-plan-input').forEach(radio => {
        if (radio.value === sellingPlanId && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('click', { bubbles: true }));
          updated = true;
        }
      });
    }
    
    if (updated) {
      setTimeout(() => { if (!isUpdating) updateUIFromLoop(); }, 300);
    }
  }
  
  function updateCTAText(option) {
    const ctaText = document.querySelector('.cta-text');
    if (ctaText) {
      ctaText.textContent = option === 'subscribe' ? 'Subscribe - ' : 'Add to Cart - ';
    }
    setTimeout(updateCTAPrice, 100);
  }
  
  function updateCTAPrice() {
    const ctaPrice = document.querySelector('.cta-price');
    const ctaCompare = document.querySelector('.cta-price-compare');
    if (!ctaPrice) return;
    
    const subscribeSelected = document.querySelector('input[name="purchase-option"][value="subscribe"]:checked');
    
    if (subscribeSelected) {
      const subscriptionPrice = document.getElementById('hero-subscription-price');
      if (subscriptionPrice) {
        ctaPrice.textContent = subscriptionPrice.textContent;
        if (ctaCompare) ctaCompare.style.display = 'none';
      }
    } else {
      const oneTimePrice = document.querySelector('.onetime-label .option-price');
      if (oneTimePrice) {
        const salePrice = oneTimePrice.querySelector('span[aria-label="Sale price"]');
        const comparePrice = oneTimePrice.querySelector('del');
        
        if (salePrice && comparePrice) {
          ctaPrice.textContent = salePrice.textContent;
          if (ctaCompare) {
            ctaCompare.innerHTML = `<del aria-label="Original price">${comparePrice.textContent}</del>`;
            ctaCompare.style.display = 'inline';
          }
        } else {
          ctaPrice.textContent = oneTimePrice.textContent;
          if (ctaCompare) ctaCompare.style.display = 'none';
        }
      }
    }
  }
  
  function setupLoopListeners() {
    const loopContainer = document.querySelector(`#loop-subscription-container-${productId}`);
    if (!loopContainer) return;
    
    const observer = new MutationObserver((mutations) => {
      if (!isUpdating && mutations.some(m => m.type === 'childList' || m.type === 'characterData')) {
        updateUIFromLoop();
      }
    });
    
    observer.observe(loopContainer, { childList: true, subtree: true, characterData: true });
  }
  
  function updateUIFromLoop() {
    if (isUpdating) return;
    
    const subscriptionOption = document.getElementById('hero-subscription-option');
    const loopPrices = document.querySelectorAll('.loop-subscription-group-price-amount');
    
    if (loopPrices.length > 0 && subscriptionOption) {
      subscriptionOption.style.display = 'block';
      
      const heroPrice = document.getElementById('hero-subscription-price');
      if (heroPrice && loopPrices[0]) {
        heroPrice.textContent = loopPrices[0].textContent;
      }
      
      updateSubscriptionText();
      
      if (!isInitialized || document.getElementById('hero-frequency-select')?.children.length <= 1) {
        updateFrequencyOptions();
      }
    } else if (subscriptionOption) {
      subscriptionOption.style.display = 'none';
    }
    
    updateCTAPrice();
  }
  
  function updateSubscriptionText() {
    const badge = document.querySelector('.loop-subscription-group-discount-badge');
    const subText = document.getElementById('hero-subscription-text');
    const discountText = document.getElementById('discount-text');
    
    if (badge) {
      const match = badge.textContent.trim().match(/(\d+)%/);
      if (match) {
        const percent = match[1];
        if (subText) subText.textContent = `- Subscribe & Save ${percent}%`;
        if (discountText) discountText.textContent = `${percent}%`;
      }
    }
  }
  
  function updateFrequencyOptions() {
    if (isUpdating) return;
    
    const select = document.getElementById('hero-frequency-select');
    if (!select) return;
    
    // Clear existing options except first
    while (select.children.length > 1) {
      select.removeChild(select.lastChild);
    }
    
    const addedValues = new Set();
    
    // From Loop selectors
    document.querySelectorAll('.loop-selling-plan-selector option').forEach(opt => {
      if (opt.value && !addedValues.has(opt.value)) {
        const newOpt = document.createElement('option');
        newOpt.value = opt.value;
        newOpt.textContent = opt.textContent.trim();
        select.appendChild(newOpt);
        addedValues.add(opt.value);
      }
    });
    
    // From radio inputs if no selectors
    if (addedValues.size === 0) {
      document.querySelectorAll('.custom-plan-input').forEach(radio => {
        if (radio.value && !addedValues.has(radio.value)) {
          const label = document.querySelector(`label[for="${radio.id}"]`);
          const newOpt = document.createElement('option');
          newOpt.value = radio.value;
          newOpt.textContent = label?.textContent.trim() || `Plan ${radio.value}`;
          select.appendChild(newOpt);
          addedValues.add(radio.value);
        }
      });
    }
    
    // Auto-select first option on init
    if (select.children.length > 1 && !isInitialized) {
      select.selectedIndex = 1;
    }
  }
  
  function setupVariantIntegration() {
    document.querySelectorAll('.variant-option input').forEach(input => {
      input.addEventListener('change', () => {
        setTimeout(() => { if (!isUpdating) updateUIFromLoop(); }, 300);
      });
    });
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForLoop);
  } else {
    waitForLoop();
  }
})();
